import { Linkedin, ArrowUp } from "lucide-react";
import { PROFILE } from "../data/content";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/10 bg-charcoal-900">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
        <div>
          <img src={PROFILE.logo} alt="Dheeraj Chawla" className="h-16 w-auto object-contain -ml-1" />
          <p className="text-cream/45 mt-3 max-w-sm text-sm">{PROFILE.title}, {PROFILE.company} · Digital growth partner to founders worldwide.</p>
        </div>
        <div className="flex items-center gap-4">
          <a data-testid="footer-linkedin" href={PROFILE.linkedin} target="_blank" rel="noreferrer" className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center text-cream/70 hover:border-gold hover:text-gold transition-all">
            <Linkedin size={18} />
          </a>
          <button data-testid="footer-top" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center text-cream/70 hover:border-gold hover:text-gold transition-all">
            <ArrowUp size={18} />
          </button>
        </div>
      </div>
      <div className="hairline my-10" />
      <div className="flex flex-col sm:flex-row justify-between gap-3 text-xs text-cream/35">
        <p>© {new Date().getFullYear()} Dheeraj Chawla. All rights reserved.</p>
        <p>Delhi NCR · Available worldwide</p>
      </div>
    </div>
  </footer>
);
